<div class="row">
  <div class="col">
    <rask-selector label="Metod" class="dd-width" [values]="anmalanForyngringsmetoder"
      [(ngModel)]="anmalanForyngringsmetod"
      [disabled]="readonly"
      [canDelete]="false"
      (change)="metodChanged()">
    </rask-selector>
  </div>
</div>
<div class="row">
  <div class="col mb-4">
    @if (anmalanForyngringsmetod) {
      <div class="pt-2">
        @if (atgardMbf?.anmalanTradslag?.length > 0) {
          <div>
            @for (anmalanTradslag of atgardMbf.anmalanTradslag; track anmalanTradslag; let i = $index) {
              <div>
                <rask-foryngring-tradslag
                  [atgardMbf]="atgardMbf"
                  [readonly]="readonly"
                  (deleted)="deleted($event)"
                  [index]="i"
                  [anmalanTradslag]="anmalanTradslag"
                  [allatradslag]="allatradslag">
                </rask-foryngring-tradslag>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="pt-2">
      <rask-action-button icon="fas fa-plus" [disabled]="readonly" (click)="addRow()" class="float-start">Lägg till trädslag</rask-action-button>
    </div>
  </div>
</div>